import * as angular from 'angular';
import {
  IStoreJispPay,
  IStoreJispPayListItem
} from '../../../app.retailer/modules/jispPay/models';

class JispPayPlace {
  public edit: any;
  public place: IStoreJispPayListItem;
  private currentRefundPassword: string;

  public $onChanges(onChangesObj: angular.IOnChangesObject): void {
    this.currentRefundPassword = (this.edit.model as IStoreJispPay).RefundPassword;
  }

  public isPreviousEditAccount() {
    (this.edit.model as IStoreJispPay).RefundPassword =
      (this.edit.model as IStoreJispPay).JispPayMerchantID ===
      this.place.JispPayMerchantID
        ? this.currentRefundPassword
        : '';
  }

  public toggleInput() {
    this.edit.showRefundPassword = !this.edit.showRefundPassword;
  }
}

angular.module('app.retailes.common').component('jisppayPlace', {
  template: require('./jisppay-place.html'),
  controller: JispPayPlace,
  controllerAs: 'vm',
  bindings: {
    place: '<',
    jispPayMerchants: '<',
    defaultMerchants: '<',
    waiting: '<',
    placeEdit: '=',
    placeEnabled: '=',
    save: '=',
    cancelEdit: '=',
    edit: '=',
    admineMode: '<'
  }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/components/jisppay-place/jisppay-place.component.ts